module.exports = __webpack_public_path__ + "img/user-7.0faa4a1a.svg";